import { object, string, array, number, SchemaOf } from 'yup';

import { KubernetesRegistryFormValues } from './types';

export const kubernetesRegistryValidationSchema: SchemaOf<KubernetesRegistryFormValues> =
  object({
    name: string()
      .required('Policy name is required')
      .trim()
      .min(1, 'Policy name is required'),
    environmentGroupIds: array(number().required()),
    accessRows: array(
      object({
        registryId: number().required(),
        namespaces: array(string().required()).min(
          1,
          'At least one namespace is required'
        ),
      })
    ).min(1, 'At least one registry access entry is required'),
  });
